/* @flow */
import * as React from 'react';
import to from 'to-case';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';
import type { TranslatorProps } from 'react-i18next';
import { translate } from 'react-i18next';
import { get, toString } from 'lodash';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import { documentTitleTemplate } from '../../routes';

type DocumentTitleProps = {
  routes: Array,
  stores: Array<Object>,
} & TranslatorProps;

@translate()
@withRouter
@observer
export class DocumentTitle extends ComponentWithInjectedProps<DocumentTitleProps, {}, {}> {
  componentDidMount() {
    this.changeDocumentTitle();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.location !== prevProps.location) {
      this.changeDocumentTitle();
    }
  }

  resetTitle() {
    const { REACT_APP_SHORT_NAME, REACT_APP_VERSION_NUMBER } = process.env;
    document.title = `${REACT_APP_SHORT_NAME} V${REACT_APP_VERSION_NUMBER}`;
  }

  /**
   * Here we are making sure we get a nice
   * readable title for each page
   */
  getTitleData(stores, route) {
    const data = {};
    const keys = route.title_keys;

    if (stores.length && keys) {
      stores.forEach(store => {
        keys.forEach(key => {
          if (get(store, key)) {
            const keySplit = key.split('.');
            const dataKey = keySplit[keySplit.length - 1];
            data[`${dataKey}`] = to.title(to.snake(toString(get(store, key))).replace(/_/g, ' '));
          }
        });
      });
    }

    return data;
  }

  changeDocumentTitle() {
    const { routes, t, match, stores } = this.props;
    const route = routes.filter(item => item.path === match.path)[0];
    const data = this.getTitleData(stores, route);

    if (route && data !== false) {
      if (route.title) document.title = documentTitleTemplate(t(route.title, data));
      else {
        console.warn(
          `${
            route.path
          } is missing a document title, visit src/routes/index.js to add title property`
        );
        this.resetTitle();
      }
    }

    return '';
  }

  render() {
    return <React.Fragment>{this.changeDocumentTitle()}</React.Fragment>;
  }
}
